const cols = [
  {
    title: "快速导航",
    links: [
      { href: "#latest", label: "最新实锤" },
      { href: "#library", label: "证据库" },
      { href: "#timeline", label: "时间线拆解" },
      { href: "#archive", label: "关键词归档" },
    ],
  },
  {
    title: "证据说明",
    links: [
      { href: "#standard", label: "核验标准" },
      { href: "#about", label: "关于本站" },
      { href: "#about", label: "线索提交" },
      { href: "#about", label: "免责声明" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-300 bg-background-200">
      <div className="mx-auto max-w-[1200px] px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center bg-primary-600 text-background-50">
                <i className="ri-shield-check-line flex h-5 w-5 items-center justify-center text-lg" />
              </span>
              <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
                八酱黑料
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              汇总截图、录音、视频等硬核材料，逐项拆解争议点，只摆实锤、不空谈，帮你理性判断事件真相。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-2">
              {["实锤", "石锤", "证据拆解", "材料归档"].map((k) => (
                <span
                  key={k}
                  className="rounded-full border border-background-300 bg-background-50 px-2.5 py-1 text-xs text-foreground-600"
                >
                  {k}
                </span>
              ))}
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="font-heading text-sm font-semibold text-foreground-950">
                <a href="#top">{c.title}</a>
              </h4>
              <ul className="mt-4 space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="text-sm text-foreground-600 transition-colors hover:text-foreground-950"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col gap-2 border-t border-background-300 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-600">
            © 2026 八酱黑料 · 实锤证据挖掘整理归档
          </p>
          <p className="text-xs text-foreground-500">
            本页内容仅作资料整理与争议梳理，转载请注明出处。
          </p>
        </div>
      </div>
    </footer>
  );
}